// WHAT: Buzzer Page Component
// WHY:  Simple page wrapper that renders BuzzerTab
// DOMAIN: Productivity → TimeTracQ
// DEPENDENCIES: BuzzerTab component
// RISKS:
//   - NOTE: This is a thin wrapper with no additional logic

import { type FC } from "react";

import { BuzzerTab } from "../../screen/tabs/BuzzerTab";

/**
 * WHAT:
 *   Page component that renders the Buzzer tab.
 *
 * WHY:
 *   Provides routing entry point for buzzer/timer functionality.
 *
 * BEHAVIOR:
 *   - Simply renders BuzzerTab component
 *   - No additional logic or state management
 *
 * RISKS:
 *   - NOTE: This is a thin wrapper - consider removing if not needed for routing
 *
 * @returns {JSX.Element} The buzzer page component
 *
 */
export const BuzzerPage: FC = () => {
  return <BuzzerTab />;
};
